interface AIAutomationCardProps {
  className?: string;
}

export function AIAutomationCard({ className }: AIAutomationCardProps) {
  return (
    <div
      className={`absolute bottom-0 left-0 flex flex-col items-center gap-2 z-10 w-32 lg:w-40 p-3.5 lg:p-[18px] ${className || ''}`}
      style={{
        alignItems: 'center',
        borderRadius: '20px',
        border: '1px solid rgba(59, 130, 246, 0.30)',
        background:
          'linear-gradient(161deg, rgba(20, 40, 80, 0.95) 0%, rgba(12, 28, 58, 0.95) 100%)',
        boxShadow:
          '0 0 50px 0 rgba(59, 130, 246, 0.12), 0 0 120px 0 rgba(59, 130, 246, 0.04), 0 16px 48px 0 rgba(0, 0, 0, 0.40), 0 1px 0 1px rgba(255, 255, 255, 0.08) inset, 0 0 30px 1px rgba(59, 130, 246, 0.03) inset',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div
        style={{
          display: 'flex',
          height: '63px',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        {/* Sol üst badge */}
        <div
          style={{
            display: 'flex',
            padding: '2px 8px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            position: 'absolute',
            left: '-11px',
            top: '-6px',
            borderRadius: '6px',
            border: '1px solid rgba(96, 165, 250, 0.40)',
            background: 'linear-gradient(120deg, #1E40AF 0%, #3B82F6 100%)',
            boxShadow: '0 0 12px 0 rgba(59, 130, 246, 0.40)',
          }}
        >
          <div style={{ fontSize: '8px', color: 'white', fontWeight: '600' }}>
            AI
          </div>
        </div>

        {/* Robot container */}
        <div
          style={{
            display: 'flex',
            width: '64px',
            height: '64px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '7px',
            flexShrink: 0,
            borderRadius: '18px',
            border: '1px solid rgba(96, 165, 250, 0.20)',
            background: 'linear-gradient(145deg, #1E2D52 0%, #283A60 100%)',
            boxShadow:
              '0 8px 32px 0 rgba(0, 0, 0, 0.50), 0 0 30px 0 rgba(59, 130, 246, 0.12), 0 1px 0 1px rgba(255, 255, 255, 0.08) inset',
          }}
        >
          {/* Gözler */}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '10px',
            }}
          >
            <div
              style={{
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                background: 'rgba(96, 165, 250, 1)',
              }}
            ></div>
            <div
              style={{
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                background: 'rgba(96, 165, 250, 1)',
              }}
            ></div>
          </div>

          {/* Ağız */}
          <div
            style={{
              width: '18px',
              height: '2px',
              flexShrink: 0,
              borderRadius: '2px',
              background: 'rgba(96, 165, 250, 0.50)',
            }}
          ></div>
        </div>
      </div>

      <div
        style={{
          color: 'rgba(255, 255, 255, 0.65)',
          fontFamily: 'Inter',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '700',
          lineHeight: 'normal',
          textAlign: 'center',
        }}
      >
        AI Otomasyon
      </div>
    </div>
  );
}
